import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getOrganisationUsers(organisationId, isAllocatedTo = true, excludeArchived = false) {
  return function(dispatch, getState) {
    const endpoint = '/users';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId,
        isAllocatedTo,
        excludeArchived
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const users = response.data;
        const type = isAllocatedTo ? 'UPDATE_ALLOCATED_USERS' : 'UPDATE_UNALLOCATED_USERS';
        dispatch({ type, users });
      },
     error => dispatch(APIError(error, 'Error getting currentOrganisation users'))
    );
  };
}




// WEBPACK FOOTER //
// ./src/actions/organisations/userCreators.js